// extracted by mini-css-extract-plugin
export default {"content":"DisplaySuccessMessage_content__PhjLH","header":"DisplaySuccessMessage_header__5rPg1","info":"DisplaySuccessMessage_info__0jGhh"};